
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soft/atoms/japan/outfielder",
      function () {
        return require("private-next-pages/soft/atoms/japan/outfielder/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soft/atoms/japan/outfielder"])
      });
    }
  